import { render, staticRenderFns } from "./WarningCard.vue?vue&type=template&id=640d4b9d&scoped=true"
import script from "./WarningCard.vue?vue&type=script&lang=js"
export * from "./WarningCard.vue?vue&type=script&lang=js"
import style0 from "./WarningCard.vue?vue&type=style&index=0&id=640d4b9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d4b9d",
  null
  
)

export default component.exports